module.exports = "/packs/images/homepage/facilities/library_desktop~af81781adc399e938f55c7b86adcba1a.jpg";